"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Attachment = _interopRequireDefault(require("../model/Attachment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* Attachments service.
* @module api/AttachmentsApi
* @version 0.0.1
*/
var AttachmentsApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new AttachmentsApi. 
  * @alias module:api/AttachmentsApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function AttachmentsApi(apiClient) {
    _classCallCheck(this, AttachmentsApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Callback function to receive the result of the attachmentsRelatedObjectIdGet operation.
   * @callback module:api/AttachmentsApi~attachmentsRelatedObjectIdGetCallback
   * @param {String} error Error message, if any.
   * @param {Array.<module:model/Attachment>} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * @param {String} relatedObjectId 
   * @param {module:api/AttachmentsApi~attachmentsRelatedObjectIdGetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Array.<module:model/Attachment>}
   */
  return _createClass(AttachmentsApi, [{
    key: "attachmentsRelatedObjectIdGet",
    value: function attachmentsRelatedObjectIdGet(relatedObjectId, callback) {
      var postBody = null;
      // verify the required parameter 'relatedObjectId' is set
      if (relatedObjectId === undefined || relatedObjectId === null) {
        throw new Error("Missing the required parameter 'relatedObjectId' when calling attachmentsRelatedObjectIdGet");
      }
      var pathParams = {
        'related_object_id': relatedObjectId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['BearerAuth'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_Attachment["default"]];
      return this.apiClient.callApi('/attachments/{related_object_id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the attachmentsUploadRelatedObjectIdPost operation.
     * @callback module:api/AttachmentsApi~attachmentsUploadRelatedObjectIdPostCallback
     * @param {String} error Error message, if any.
     * @param {String} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} relatedObjectId 
     * @param {Object} opts Optional parameters
     * @param {File} opts.file 
     * @param {module:api/AttachmentsApi~attachmentsUploadRelatedObjectIdPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link String}
     */
  }, {
    key: "attachmentsUploadRelatedObjectIdPost",
    value: function attachmentsUploadRelatedObjectIdPost(relatedObjectId, opts, callback) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'relatedObjectId' is set
      if (relatedObjectId === undefined || relatedObjectId === null) {
        throw new Error("Missing the required parameter 'relatedObjectId' when calling attachmentsUploadRelatedObjectIdPost");
      }
      var pathParams = {
        'related_object_id': relatedObjectId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {
        'file': opts['file']
      };
      var authNames = ['BearerAuth'];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['text/plain'];
      var returnType = 'String';
      return this.apiClient.callApi('/attachments/upload/{related_object_id}', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the attachmentsUrlGet operation.
     * @callback module:api/AttachmentsApi~attachmentsUrlGetCallback
     * @param {String} error Error message, if any.
     * @param {String} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/AttachmentsApi~attachmentsUrlGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link String}
     */
  }, {
    key: "attachmentsUrlGet",
    value: function attachmentsUrlGet(callback) {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['BearerAuth'];
      var contentTypes = [];
      var accepts = ['text/plain'];
      var returnType = 'String';
      return this.apiClient.callApi('/attachments/url', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
  }]);
}();